import { Condition } from './Condition';
export class TableOptions {
  conditions: Condition[];
  tablecols: string[];
  additionslfilter: string;
  keyid: string;
  limit: number;
  offset: number;
  orderby: string;
  ordertype: string;
}
